import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { DateService } from '@thewhite/react-global-module/lib/services';
import { DateType } from '@thewhite/react-global-module/lib/types';
import * as t from 'io-ts';
import USER_AUTHORITIES from '../../Auth/enums/userAuthorities';
import UserAccount, { UserAccountType } from './userAccount';
import UserProfile, { UserProfileType } from './userProfile';

export const UserType = t.interface({
    id: t.string,
    authorities: t.array(t.string),
    accounts: t.array(UserAccountType),
    enabled: t.union([t.boolean, t.undefined]),
    createDate: t.union([DateType, t.null, t.undefined]),
    profile: t.union([UserProfileType, t.null, t.undefined]),
});

export interface UserDto extends t.TypeOf<typeof UserType> {
}

class User {
    id: string;
    enabled: boolean;
    createDate: Date | null;
    accounts: UserAccount[];
    profile: UserProfile | null;
    authorities: SimpleObjectInterface[];

    constructor(params: UserDto) {
        this.id = params.id;
        this.enabled = params.enabled ?? false;
        this.createDate = DateService.getValidDate(params.createDate ?? null);
        this.profile = !!params.profile ? new UserProfile(params.profile) : null;
        this.authorities  = params.authorities.length
            ? params.authorities.map((authority: string) => USER_AUTHORITIES[authority])
            : [];
        this.accounts = !!params.accounts.length ? params.accounts.map(account => new UserAccount(account)) : [];
    }
}

export default User;
